import React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { DEFICIENCIES_AND_CITATIONS } from '../../../constants/index';
import type { HTMLElementEvent } from '../../../models/Types';
import InlineToolTip from '../../Widgets/InlineTooltip';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function DeficienciesAndCitations({ section, setSectionValues }: Props): JSX.Element {
  function onNoDeficienciesAndCitations(): void {
    setSectionValues({
      [DEFICIENCIES_AND_CITATIONS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesDeficienciesAndCitations(): void {
    setSectionValues({
      [DEFICIENCIES_AND_CITATIONS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onDescriptionChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [DEFICIENCIES_AND_CITATIONS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  const deficienciesAndCitationsEnabled = section.getFieldValue(DEFICIENCIES_AND_CITATIONS.FIELD_NAME.IS_ENABLED);
  const deficienciesAndCitationsDescription = section.getFieldValue(DEFICIENCIES_AND_CITATIONS.FIELD_NAME.DESCRIPTION);

  return (
    <FormField
      label={
        <Label size="lg">
          Have you received any notices of{' '}
          <InlineToolTip tooltipBodyText="Deficiencies or citations related to health and sanitation, nuisances, and property maintenance are to be included.">
            deficiencies or citations
          </InlineToolTip>{' '}
          within the last 24 months?
        </Label>
      }
      control={
        <YesAndNoExpansion
          yesHandler={onYesDeficienciesAndCitations}
          noHandler={onNoDeficienciesAndCitations}
          yesActive={deficienciesAndCitationsEnabled}
        >
          <FormField
            label={<Label>Describe these deficiencies or citations</Label>}
            control={
              <Textarea resize="vertical" value={deficienciesAndCitationsDescription} onChange={onDescriptionChange} />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
